import { Component, OnInit, inject } from '@angular/core';
import {TranslationService} from '../../services/translation.service';
import {ModalCharteDeontologiqueComponent} from '../modal-charte-deontologique/modal-charte-deontologique.component';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import {FormsModule} from '@angular/forms';

import {MatButton} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-modal-descriptif-type-frais-financement',
    templateUrl: './modal-descriptif-type-frais-financement.component.html',
    styleUrls: ['./modal-descriptif-type-frais-financement.component.scss'],
    providers: [TranslationService],
    imports: [FormsModule, MatDialogActions, MatDialogClose, MatButton, TranslateModule, MatDialogTitle, MatDialogContent]
})
export class ModalDescriptifTypeFraisFinancementComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalCharteDeontologiqueComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    auth = inject(AuthentificationService);
    translationService = inject(TranslationService);


    constructor() {
    }

    ngOnInit() {
    }

    public updateFraisTypeDescription() {
        this.dialogRef.close(this.data['descriptionUser'].trim());
    }

}
